export type Mutation = 'updateReports';

export class Mutations {
    public static readonly SetAllReports: string = 'setAllReports';
    public static readonly SetAllReportsPage: string = 'setAllReportsPage';
    public static readonly SetAllReportsPageSize: string = 'setAllReportsPageSize';
    public static readonly SetAllReportsTotalPages: string = 'setAllReportsTotalPages';
    public static readonly SetAllReportsTotalReports: string = 'setAllReportsTotal';
    public static readonly SetAllReportsFilterStatus: string = 'setAllReportsFilterStatus';
    public static readonly SetAllReportsFrom: string = 'setAllReportsFrom';
    public static readonly SetAllReportsTo: string = 'setAllReportsTo';
    public static readonly SetAllReportOperators: string = 'setAllReportOperators';
    public static readonly SetAllReportBooleanValues: string = 'setAllReportBooleanValues';
    public static readonly SetAllReportLogicalOperators: string = 'setAllReportLogicalOperators';
}
